import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { UiModule } from '@lockton-apps/shared/ui/lui';

import { FormFieldWrapperComponent } from './form-field-wrapper.component';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';

@NgModule({
  declarations: [FormFieldWrapperComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    MatFormFieldModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'form-field',
          component: FormFieldWrapperComponent,
        },
      ],
    }),
    CastObservablePipe,
  ],
})
export class FormFieldWrapperModule {}
